import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { bool, func, object } from 'prop-types';
import { getRedeemText } from '@airasia-common/libraries/i18n/LocaleHelper';
import ResponsiveModal from '../Modal/ResponsiveModal';
import { Row, Text, Wrapper } from '../';
import Tooltip from '../Tooltip';
import StyledSwitch from '../StyledSwitch';
import Icon from '../Icon';
import BigpointsInfo from './BigpointsInfo';

const InfoIcon = styled(Icon)`
  position: relative;
  left: 5px;
`;

const ReedemText = styled(Text)`
  font-family: DM Sans;
  font-size: ${props => (props.isMobileView ? '14px' : '16px')};
  font-style: normal;
  font-weight: 500;
  line-height: ${props => (props.isMobileView ? '21px' : '24px')};
  letter-spacing: 0em;
  text-align: ${props => (props.isMobileView ? 'left' : 'right')};
  pointerevents: none;
  color: #4c4c50;
`;

const HotelSwitch = props => {
  const { bigPoints, isLoggedIn, isMobileView, updateFilter, filter } = props;
  const [modalIsOpen, setIsOpen] = useState(false);
  const [checked, setChecked] = useState(filter.applyBigpoints);

  useEffect(() => {
    updateFilter({ applyBigpoints: checked });
  }, [checked, updateFilter]);

  const closeModal = () => {
    setIsOpen(false);
  };
  const openModal = () => {
    setIsOpen(true);
  };

  const availableBalance = `${bigPoints.available_amount.currency} ${bigPoints.available_amount.value}`;

  const desktopStyle = {
    position: 'absolute',
    right: 0,
  };

  const mobileStyle = {
    marginTop: '18px',
    marginBottom: '18px',
  };

  return (
    isLoggedIn && (
      <>
        <Wrapper>
          <ResponsiveModal
            isOpen={modalIsOpen}
            onClose={closeModal}
            width="100%"
            height="fit-content"
          >
            <BigpointsInfo
              isMobileView={isMobileView}
              closeModal={closeModal}
              bigPoints={bigPoints}
            ></BigpointsInfo>
          </ResponsiveModal>
        </Wrapper>

        <Row style={isMobileView ? mobileStyle : desktopStyle}>
          <Tooltip
            content={
              <BigpointsInfo
                isMobileView={isMobileView}
                bigPoints={bigPoints}
              ></BigpointsInfo>
            }
            atTop={true}
          >
            <ReedemText isMobileView={isMobileView}>
              {getRedeemText(availableBalance)}
            </ReedemText>
          </Tooltip>
          {isMobileView && (
            <InfoIcon
              icon="InfoOutlinedIcon"
              onClick={openModal}
              fontsize="titleSmall"
            />
          )}
          <Wrapper
            style={isMobileView ? { position: 'absolute', right: '0px' } : {}}
          >
            <StyledSwitch checked={checked} onChangeHandler={setChecked} />
          </Wrapper>
        </Row>
      </>
    )
  );
};

HotelSwitch.propTypes = {
  isLoggedIn: bool,
  isMobileView: bool,
  addBigPoints: bool,
  filter: object,
  updateFilter: func,
  bigPoints: object,
};

export default HotelSwitch;
